<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-3">
          <div class="copyright text-left">
            Version: {{version}}
          </div>
        </div>
        <div class="offset-6 col-3">
          <div class="copyright text-right">
            2019 &copy; Wayfare SRL.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  computed: {
    version() {
      return `${this.$beast.version} (#${this.$beast.build})`;
    }
  }
};

</script>
<style>

</style>
